import { combineReducers, configureStore } from "@reduxjs/toolkit";

const updateReducers = reducers => extraReducers => ({
  ...reducers,
  ...extraReducers
});

const updateServices = services => extraServices => {
  Object.keys(extraServices).forEach(name => {
    // eslint-disable-next-line no-param-reassign
    services[name] = extraServices[name];
  });

  return services;
};

// There should be at least one initial reducer, so redux won't throw an error
const defaultReducer = (state = {}) => state;

export default (
  { reducers = { defaultReducer }, middleware = [], services = {} } = {},
  options
) => {
  const defaultServices = {};
  const extraReducers = {};

  const addServices = updateServices(defaultServices);
  const addReducers = updateReducers(reducers);

  const store = configureStore({
    reducer: addReducers(),
    middleware: getDefaultMiddleware => {
      const currentMiddleware = getDefaultMiddleware({
        thunk: {
          extraArgument: addServices(services)
        }
      });

      return middleware.reduce(
        (currentMiddlewareVal, middlewareVal) =>
          currentMiddlewareVal.concat(middlewareVal),
        currentMiddleware
      );
    },
    ...options
  });

  store.addReducer = (key, asyncReducer) => {
    extraReducers[key] = asyncReducer;
    store.replaceReducer(combineReducers(addReducers(extraReducers)));
  };

  store.addServices = addServices;

  return store;
};
